import { CoralogixRum, CoralogixLogSeverity } from "@coralogix/browser";

const PREFIX = "[zuug-landing]";

function toSeverity(level) {
	if (level === "error") return CoralogixLogSeverity.Error;
	if (level === "warn") return CoralogixLogSeverity.Warning;
	return CoralogixLogSeverity.Info;
}

/**
 * Structured logs: browser console + Coralogix RUM custom logs (when SDK is initialized).
 * Keep payloads small; never log secrets, tokens, or full base64 payloads.
 *
 * @param {"info"|"warn"|"error"} [level="info"]
 */
export function landingLog(scope, event, extra = {}, level = "info") {
	const entry = { ts: new Date().toISOString(), scope, event, ...extra };
	const msg = `${PREFIX} ${scope} · ${event}`;
	try {
		if (level === "error") {
			console.error(PREFIX, JSON.stringify(entry));
		} else if (level === "warn") {
			console.warn(PREFIX, JSON.stringify(entry));
		} else {
			console.info(PREFIX, JSON.stringify(entry));
		}
	} catch {
		console.info(PREFIX, scope, event, extra);
	}

	try {
		CoralogixRum.log(toSeverity(level), msg, entry);
	} catch {
		/* RUM not initialized or unavailable */
	}
}

/**
 * Axios transformResponse: if the server returns 2xx with a non-JSON body
 * (e.g. plain `OK`), the default JSON parser rejects and axios enters `.catch`
 * even though HTTP succeeded. This keeps the promise chain aligned with HTTP.
 */
export function parseJsonOrRawString(data) {
	if (data == null || data === "") return data;
	if (typeof data !== "string") return data;
	try {
		return JSON.parse(data);
	} catch {
		landingLog("http", "response-body-not-json", {
			length: data.length,
			head: data.slice(0, 64),
		});
		return data;
	}
}
